const salesforceCounties = {
  AU: [
    { label: 'Australian Capital Territory', value: 'Australian Capital Territory' },
    { label: 'New South Wales', value: 'New South Wales' },
    { label: 'Northern Territory', value: 'Northern Territory' },
    { label: 'Queensland', value: 'Queensland' },
    { label: 'South Australia', value: 'South Australia' },
    { label: 'Tasmania', value: 'Tasmania' },
    { label: 'Victoria', value: 'Victoria' },
    { label: 'Western Australia', value: 'Western Australia' },
  ],
  BR: [
    { label: 'Acre', value: 'Acre' },
    { label: 'Alagoas', value: 'Alagoas' },
    { label: 'Amapá', value: 'Amapá' },
    { label: 'Amazonas', value: 'Amazonas' },
    { label: 'Bahia', value: 'Bahia' },
    { label: 'Ceará', value: 'Ceará' },
    { label: 'Distrito Federal', value: 'Distrito Federal' },
    { label: 'Espírito Santo', value: 'Espírito Santo' },
    { label: 'Goiás', value: 'Goiás' },
    { label: 'Maranhão', value: 'Maranhão' },
    { label: 'Mato Grosso', value: 'Mato Grosso' },
    { label: 'Mato Grosso do Sul', value: 'Mato Grosso do Sul' },
    { label: 'Minas Gerais', value: 'Minas Gerais' },
    { label: 'Pará', value: 'Pará' },
    { label: 'Paraíba', value: 'Paraíba' },
    { label: 'Paraná', value: 'Paraná' },
    { label: 'Pernambuco', value: 'Pernambuco' },
    { label: 'Piauí', value: 'Piauí' },
    { label: 'Rio de Janeiro', value: 'Rio de Janeiro' },
    { label: 'Rio Grande do Norte', value: 'Rio Grande do Norte' },
    { label: 'Rio Grande do Sul', value: 'Rio Grande do Sul' },
    { label: 'Rondônia', value: 'Rondônia' },
    { label: 'Roraima', value: 'Roraima' },
    { label: 'Santa Catarina', value: 'Santa Catarina' },
    { label: 'Sergipe', value: 'Sergipe' },
    { label: 'São Paulo', value: 'São Paulo' },
    { label: 'Tocantins', value: 'Tocantins' },
  ],
  CA: [
    { label: 'Alberta', value: 'Alberta' },
    { label: 'British Columbia', value: 'British Columbia' },
    { label: 'Manitoba', value: 'Manitoba' },
    { label: 'New Brunswick', value: 'New Brunswick' },
    { label: 'Newfoundland and Labrador', value: 'Newfoundland and Labrador' },
    { label: 'Nova Scotia', value: 'Nova Scotia' },
    { label: 'Northwest Territories', value: 'Northwest Territories' },
    { label: 'Nunavut', value: 'Nunavut' },
    { label: 'Ontario', value: 'Ontario' },
    { label: 'Prince Edward Island', value: 'Prince Edward Island' },
    { label: 'Quebec', value: 'Quebec' },
    { label: 'Saskatchewan', value: 'Saskatchewan' },
    { label: 'Yukon Territories', value: 'Yukon Territories' },
  ],
  CN: [
    { label: 'Anhui', value: 'Anhui' },
    { label: 'Beijing', value: 'Beijing' },
    { label: 'Chongqing', value: 'Chongqing' },
    { label: 'Chinese Taipei', value: 'Chinese Taipei' },
    { label: 'Fujian', value: 'Fujian' },
    { label: 'Gansu', value: 'Gansu' },
    { label: 'Guangdong', value: 'Guangdong' },
    { label: 'Guangxi', value: 'Guangxi' },
    { label: 'Guizhou', value: 'Guizhou' },
    { label: 'Hebei', value: 'Hebei' },
    { label: 'Heilongjiang', value: 'Heilongjiang' },
    { label: 'Hubei', value: 'Hubei' },
    { label: 'Hunan', value: 'Hunan' },
    { label: 'Jiangsu', value: 'Jiangsu' },
    { label: 'Jiangxi', value: 'Jiangxi' },
    { label: 'Jilin', value: 'Jilin' },
    { label: 'Liaoning', value: 'Liaoning' },
    { label: 'Macao', value: 'Macao' },
    { label: 'Nei Mongol', value: 'Nei Mongol' },
    { label: 'Ningxia', value: 'Ningxia' },
    { label: 'Qinghai', value: 'Qinghai' },
    { label: 'Shaanxi', value: 'Shaanxi' },
    { label: 'Shandong', value: 'Shandong' },
    { label: 'Shanghai', value: 'Shanghai' },
    { label: 'Shanxi', value: 'Shanxi' },
    { label: 'Sichuan', value: 'Sichuan' },
    { label: 'Tianjin', value: 'Tianjin' },
    { label: 'Xinjiang', value: 'Xinjiang' },
    { label: 'Xizang', value: 'Xizang' },
    { label: 'Yunnan', value: 'Yunnan' },
    { label: 'Zhejiang', value: 'Zhejiang' },
  ],
  ES: [
    { label: 'Albacete', value: 'Albacete' },
    { label: 'Alicante/Alacant', value: 'Alicante/Alacant' },
    { label: 'Almería', value: 'Almería' },
    { label: 'Araba/Álava', value: 'Araba/Álava' },
    { label: 'Asturias', value: 'Asturias' },
    { label: 'Badajoz', value: 'Badajoz' },
    { label: 'Balears, Illes', value: 'Balears, Illes' },
    { label: 'Barcelona', value: 'Barcelona' },
    { label: 'Bizkaia', value: 'Bizkaia' },
    { label: 'Burgos', value: 'Burgos' },
    { label: 'Cáceres', value: 'Cáceres' },
    { label: 'Cádiz', value: 'Cádiz' },
    { label: 'Cantabria', value: 'Cantabria' },
    { label: 'Castellón/Castelló', value: 'Castellón/Castelló' },
    { label: 'Ceuta', value: 'Ceuta' },
    { label: 'Ciudad Real', value: 'Ciudad Real' },
    { label: 'Córdoba', value: 'Córdoba' },
    { label: 'Coruña, A', value: 'Coruña, A' },
    { label: 'Cuenca', value: 'Cuenca' },
    { label: 'Girona', value: 'Girona' },
    { label: 'Granada', value: 'Granada' },
    { label: 'Guadalajara', value: 'Guadalajara' },
    { label: 'Gipuzkoa', value: 'Gipuzkoa' },
    { label: 'Huelva', value: 'Huelva' },
    { label: 'Huesca', value: 'Huesca' },
    { label: 'Jaén', value: 'Jaén' },
    { label: 'León', value: 'León' },
    { label: 'Lleida', value: 'Lleida' },
    { label: 'Lugo', value: 'Lugo' },
    { label: 'Madrid', value: 'Madrid' },
    { label: 'Málaga', value: 'Málaga' },
    { label: 'Melilla', value: 'Melilla' },
    { label: 'Murcia', value: 'Murcia' },
    { label: 'Navarra', value: 'Navarra' },
    { label: 'Ourense', value: 'Ourense' },
    { label: 'Palencia', value: 'Palencia' },
    { label: 'Palmas, Las', value: 'Palmas, Las' },
    { label: 'Pontevedra', value: 'Pontevedra' },
    { label: 'Rioja, La', value: 'Rioja, La' },
    { label: 'Salamanca', value: 'Salamanca' },
    { label: 'Santa Cruz de Tenerife', value: 'Santa Cruz de Tenerife' },
    { label: 'Segovia', value: 'Segovia' },
    { label: 'Sevilla', value: 'Sevilla' },
    { label: 'Soria', value: 'Soria' },
    { label: 'Tarragona', value: 'Tarragona' },
    { label: 'Teruel', value: 'Teruel' },
    { label: 'Toledo', value: 'Toledo' },
    { label: 'Valencia/València', value: 'Valencia/València' },
    { label: 'Valladolid', value: 'Valladolid' },
    { label: 'Zamora', value: 'Zamora' },
    { label: 'Zaragoza', value: 'Zaragoza' },
  ],
  GB: [
    { label: 'Avon', value: 'Avon' },
    { label: 'Bedfordshire', value: 'Bedfordshire' },
    { label: 'Berkshire', value: 'Berkshire' },
    { label: 'Birmingham', value: 'Birmingham' },
    { label: 'Borders', value: 'Borders' },
    { label: 'Buckinghamshire', value: 'Buckinghamshire' },
    { label: 'Cambridgeshire', value: 'Cambridgeshire' },
    { label: 'Central', value: 'Central' },
    { label: 'Cheshire', value: 'Cheshire' },
    { label: 'Cleveland', value: 'Cleveland' },
    { label: 'Clwyd', value: 'Clwyd' },
    { label: 'Cornwall', value: 'Cornwall' },
    { label: 'County Antrim', value: 'County Antrim' },
    { label: 'County Armagh', value: 'County Armagh' },
    { label: 'County Down', value: 'County Down' },
    { label: 'County Fermanagh', value: 'County Fermanagh' },
    { label: 'County Londonderry', value: 'County Londonderry' },
    { label: 'County Tyrone', value: 'County Tyrone' },
    { label: 'Cumbria', value: 'Cumbria' },
    { label: 'Derbyshire', value: 'Derbyshire' },
    { label: 'Devon', value: 'Devon' },
    { label: 'Dorset', value: 'Dorset' },
    { label: 'Dumfries and Galloway', value: 'Dumfries and Galloway' },
    { label: 'Durham', value: 'Durham' },
    { label: 'Dyfed', value: 'Dyfed' },
    { label: 'East Sussex', value: 'East Sussex' },
    { label: 'Edinburgh', value: 'Edinburgh' },
    { label: 'Essex', value: 'Essex' },
    { label: 'Fife', value: 'Fife' },
    { label: 'Gloucestershire', value: 'Gloucestershire' },
    { label: 'Grampian', value: 'Grampian' },
    { label: 'Gwent', value: 'Gwent' },
    { label: 'Gwynedd County', value: 'Gwynedd County' },
    { label: 'Hampshire', value: 'Hampshire' },
    { label: 'Herefordshire', value: 'Herefordshire' },
    { label: 'Hertfordshire', value: 'Hertfordshire' },
    { label: 'Highlands and Islands', value: 'Highlands and Islands' },
    { label: 'Hull', value: 'Hull' },
    { label: 'Humberside', value: 'Humberside' },
    { label: 'Isle of Anglesey County', value: 'Isle of Anglesey County' },
    { label: 'Isle of Wight', value: 'Isle of Wight' },
    { label: 'Kent', value: 'Kent' },
    { label: 'Lancashire', value: 'Lancashire' },
    { label: 'Lincolnshire', value: 'Lincolnshire' },
    { label: 'Lothian', value: 'Lothian' },
    { label: 'Merseyside', value: 'Merseyside' },
    { label: 'Mid Glamorgan', value: 'Mid Glamorgan' },
    { label: 'Norfolk', value: 'Norfolk' },
    { label: 'North Yorkshire', value: 'North Yorkshire' },
    { label: 'Northamptonshire', value: 'Northamptonshire' },
    { label: 'Northumberland', value: 'Northumberland' },
    { label: 'Nottinghamshire', value: 'Nottinghamshire' },
    { label: 'Oxfordshire', value: 'Oxfordshire' },
    { label: 'Pembrokeshire', value: 'Pembrokeshire' },
    { label: 'Powys', value: 'Powys' },
    { label: 'Rutland', value: 'Rutland' },
    { label: 'Scotland', value: 'Scotland' },
    { label: 'Shropshire', value: 'Shropshire' },
    { label: 'Somerset', value: 'Somerset' },
    { label: 'South Glamorgan', value: 'South Glamorgan' },
    { label: 'South Yorkshire', value: 'South Yorkshire' },
    { label: 'Staffordshire', value: 'Staffordshire' },
    { label: 'Strathclyde', value: 'Strathclyde' },
    { label: 'Suffolk', value: 'Suffolk' },
    { label: 'Surrey', value: 'Surrey' },
    { label: 'Tayside', value: 'Tayside' },
    { label: 'Tyne and Wear', value: 'Tyne and Wear' },
    { label: 'Warwickshire', value: 'Warwickshire' },
    { label: 'West Glamorgan', value: 'West Glamorgan' },
    { label: 'West Midlands', value: 'West Midlands' },
    { label: 'West Sussex', value: 'West Sussex' },
    { label: 'West Yorkshire', value: 'West Yorkshire' },
    { label: 'Wiltshire', value: 'Wiltshire' },
    { label: 'Worcestershire', value: 'Worcestershire' },
  ],
  IE: [
    { label: 'Carlow', value: 'Carlow' },
    { label: 'Cavan', value: 'Cavan' },
    { label: 'Clare', value: 'Clare' },
    { label: 'Cork', value: 'Cork' },
    { label: 'Donegal', value: 'Donegal' },
    { label: 'Dublin', value: 'Dublin' },
    { label: 'Galway', value: 'Galway' },
    { label: 'Kerry', value: 'Kerry' },
    { label: 'Kildare', value: 'Kildare' },
    { label: 'Kilkenny', value: 'Kilkenny' },
    { label: 'Laois', value: 'Laois' },
    { label: 'Leitrim', value: 'Leitrim' },
    { label: 'Limerick', value: 'Limerick' },
    { label: 'Longford', value: 'Longford' },
    { label: 'Louth', value: 'Louth' },
    { label: 'Mayo', value: 'Mayo' },
    { label: 'Meath', value: 'Meath' },
    { label: 'Monaghan', value: 'Monaghan' },
    { label: 'Offaly', value: 'Offaly' },
    { label: 'Roscommon', value: 'Roscommon' },
    { label: 'Sligo', value: 'Sligo' },
    { label: 'Tipperary', value: 'Tipperary' },
    { label: 'Waterford', value: 'Waterford' },
    { label: 'Westmeath', value: 'Westmeath' },
    { label: 'Wexford', value: 'Wexford' },
    { label: 'Wicklow', value: 'Wicklow' },
  ],
  IM: [{ label: 'Isle of Man', value: 'Isle of Man' }],
  IN: [
    { label: 'Andaman and Nicobar Islands', value: 'Andaman and Nicobar Islands' },
    { label: 'Andhra Pradesh', value: 'Andhra Pradesh' },
    { label: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
    { label: 'Assam', value: 'Assam' },
    { label: 'Bihar', value: 'Bihar' },
    { label: 'Chandigarh', value: 'Chandigarh' },
    { label: 'Chhattisgarh', value: 'Chhattisgarh' },
    { label: 'Dadra and Nagar Haveli', value: 'Dadra and Nagar Haveli' },
    { label: 'Daman and Diu', value: 'Daman and Diu' },
    { label: 'Delhi', value: 'Delhi' },
    { label: 'Goa', value: 'Goa' },
    { label: 'Gujarat', value: 'Gujarat' },
    { label: 'Haryana', value: 'Haryana' },
    { label: 'Himachal Pradesh', value: 'Himachal Pradesh' },
    { label: 'Jharkhand', value: 'Jharkhand' },
    { label: 'Jammu and Kashmir', value: 'Jammu and Kashmir' },
    { label: 'Karnataka', value: 'Karnataka' },
    { label: 'Kerala', value: 'Kerala' },
    { label: 'Lakshadweep', value: 'Lakshadweep' },
    { label: 'Madhya Pradesh', value: 'Madhya Pradesh' },
    { label: 'Maharashtra', value: 'Maharashtra' },
    { label: 'Manipur', value: 'Manipur' },
    { label: 'Meghalaya', value: 'Meghalaya' },
    { label: 'Mizoram', value: 'Mizoram' },
    { label: 'Nagaland', value: 'Nagaland' },
    { label: 'Odisha', value: 'Odisha' },
    { label: 'Punjab', value: 'Punjab' },
    { label: 'Puducherry', value: 'Puducherry' },
    { label: 'Rajasthan', value: 'Rajasthan' },
    { label: 'Sikkim', value: 'Sikkim' },
    { label: 'Tamil Nadu', value: 'Tamil Nadu' },
    { label: 'Telangana', value: 'Telangana' }, // if you add it
    { label: 'Tripura', value: 'Tripura' },
    { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
    { label: 'Uttarakhand', value: 'Uttarakhand' },
    { label: 'West Bengal', value: 'West Bengal' },
  ],
  IT: [
    { label: 'Agrigento', value: 'Agrigento' },
    { label: 'Alessandria', value: 'Alessandria' },
    { label: 'Ancona', value: 'Ancona' },
    { label: 'Aosta', value: 'Aosta' },
    { label: 'Ascoli Piceno', value: 'Ascoli Piceno' },
    { label: "L'Aquila", value: "L'Aquila" },
    { label: 'Arezzo', value: 'Arezzo' },
    { label: 'Asti', value: 'Asti' },
    { label: 'Avellino', value: 'Avellino' },
    { label: 'Bari', value: 'Bari' },
    { label: 'Barletta-Andria-Trani', value: 'Barletta-Andria-Trani' },
    { label: 'Belluno', value: 'Belluno' },
    { label: 'Benevento', value: 'Benevento' },
    { label: 'Bergamo', value: 'Bergamo' },
    { label: 'Biella', value: 'Biella' },
    { label: 'Bologna', value: 'Bologna' },
    { label: 'Bolzano', value: 'Bolzano' },
    { label: 'Brescia', value: 'Brescia' },
    { label: 'Brindisi', value: 'Brindisi' },
    { label: 'Cagliari', value: 'Cagliari' },
    { label: 'Caltanissetta', value: 'Caltanissetta' },
    { label: 'Campobasso', value: 'Campobasso' },
    { label: 'Carbonia-Iglesias', value: 'Carbonia-Iglesias' },
    { label: 'Caserta', value: 'Caserta' },
    { label: 'Catania', value: 'Catania' },
    { label: 'Catanzaro', value: 'Catanzaro' },
    { label: 'Cosenza', value: 'Cosenza' },
    { label: 'Cremona', value: 'Cremona' },
    { label: 'Crotone', value: 'Crotone' },
    { label: 'Cuneo', value: 'Cuneo' },
    { label: 'Enna', value: 'Enna' },
    { label: 'Ferrara', value: 'Ferrara' },
    { label: 'Fermo', value: 'Fermo' },
    { label: 'Florence', value: 'Florence' },
    { label: 'Foggia', value: 'Foggia' },
    { label: 'Forlì-Cesena', value: 'Forlì-Cesena' },
    { label: 'Frosinone', value: 'Frosinone' },
    { label: 'Genoa', value: 'Genoa' },
    { label: 'Gorizia', value: 'Gorizia' },
    { label: 'Grosseto', value: 'Grosseto' },
    { label: 'Imperia', value: 'Imperia' },
    { label: 'Isernia', value: 'Isernia' },
    { label: 'La Spezia', value: 'La Spezia' },
    { label: 'L’Aquila', value: 'L’Aquila' },
    { label: 'Lamezia Terme', value: 'Lamezia Terme' },
    { label: 'Latina', value: 'Latina' },
    { label: 'Lecco', value: 'Lecco' },
    { label: 'Lecce', value: 'Lecce' },
    { label: 'Livorno', value: 'Livorno' },
    { label: 'Lodi', value: 'Lodi' },
    { label: 'Lucca', value: 'Lucca' },
    { label: 'Macerata', value: 'Macerata' },
    { label: 'Mantua', value: 'Mantua' },
    { label: 'Massa and Carrara', value: 'Massa and Carrara' },
    { label: 'Matera', value: 'Matera' },
    { label: 'Messina', value: 'Messina' },
    { label: 'Milan', value: 'Milan' },
    { label: 'Modena', value: 'Modena' },
    { label: 'Monza and Brianza', value: 'Monza and Brianza' },
    { label: 'Naples', value: 'Naples' },
    { label: 'Nuoro', value: 'Nuoro' },
    { label: 'Novara', value: 'Novara' },
    { label: 'Olbia-Tempio', value: 'Olbia-Tempio' },
    { label: 'Oristano', value: 'Oristano' },
    { label: 'Padua', value: 'Padua' },
    { label: 'Palermo', value: 'Palermo' },
    { label: 'Parma', value: 'Parma' },
    { label: 'Pavia', value: 'Pavia' },
    { label: 'Pesaro and Urbino', value: 'Pesaro and Urbino' },
    { label: 'Pescara', value: 'Pescara' },
    { label: 'Piacenza', value: 'Piacenza' },
    { label: 'Pisa', value: 'Pisa' },
    { label: 'Pistoia', value: 'Pistoia' },
    { label: 'Prato', value: 'Prato' },
    { label: 'Ragusa', value: 'Ragusa' },
    { label: 'Ravenna', value: 'Ravenna' },
    { label: 'Reggio Calabria', value: 'Reggio Calabria' },
    { label: 'Reggio Emilia', value: 'Reggio Emilia' },
    { label: 'Rieti', value: 'Rieti' },
    { label: 'Rimini', value: 'Rimini' },
    { label: 'Rome', value: 'Rome' },
    { label: 'Rovigo', value: 'Rovigo' },
    { label: 'Salerno', value: 'Salerno' },
    { label: 'San Marino', value: 'San Marino' },
    { label: 'Sassari', value: 'Sassari' },
    { label: 'Savona', value: 'Savona' },
    { label: 'Siena', value: 'Siena' },
    { label: 'Sondrio', value: 'Sondrio' },
    { label: 'Syracuse', value: 'Syracuse' },
    { label: 'Taranto', value: 'Taranto' },
    { label: 'Teramo', value: 'Teramo' },
    { label: 'Terni', value: 'Terni' },
    { label: 'Trento', value: 'Trento' },
    { label: 'Trapani', value: 'Trapani' },
    { label: 'Trieste', value: 'Trieste' },
    { label: 'Treviso', value: 'Treviso' },
    { label: 'Turin', value: 'Turin' },
    { label: 'Udine', value: 'Udine' },
    { label: 'Varese', value: 'Varese' },
    { label: 'Vercelli', value: 'Vercelli' },
    { label: 'Verbano-Cusio-Ossola', value: 'Verbano-Cusio-Ossola' },
    { label: 'Venice', value: 'Venice' },
    { label: 'Verona', value: 'Verona' },
    { label: 'Vibo Valentia', value: 'Vibo Valentia' },
    { label: 'Viterbo', value: 'Viterbo' },
  ],
  JE: [{ label: 'Jersey', value: 'Jersey' }],
  MX: [
    { label: 'Aguascalientes', value: 'Aguascalientes' },
    { label: 'Baja California', value: 'Baja California' },
    { label: 'Baja California Sur', value: 'Baja California Sur' },
    { label: 'Campeche', value: 'Campeche' },
    { label: 'Chiapas', value: 'Chiapas' },
    { label: 'Chihuahua', value: 'Chihuahua' },
    { label: 'Coahuila', value: 'Coahuila' },
    { label: 'Colima', value: 'Colima' },
    { label: 'Durango', value: 'Durango' },
    { label: 'Federal District', value: 'Federal District' },
    { label: 'Guanajuato', value: 'Guanajuato' },
    { label: 'Guerrero', value: 'Guerrero' },
    { label: 'Hidalgo', value: 'Hidalgo' },
    { label: 'Jalisco', value: 'Jalisco' },
    { label: 'Mexico State', value: 'Mexico State' },
    { label: 'Michoacán', value: 'Michoacán' },
    { label: 'Morelos', value: 'Morelos' },
    { label: 'Nayarit', value: 'Nayarit' },
    { label: 'Nuevo León', value: 'Nuevo León' },
    { label: 'Oaxaca', value: 'Oaxaca' },
    { label: 'Puebla', value: 'Puebla' },
    { label: 'Querétaro', value: 'Querétaro' },
    { label: 'Quintana Roo', value: 'Quintana Roo' },
    { label: 'San Luis Potosí', value: 'San Luis Potosí' },
    { label: 'Sinaloa', value: 'Sinaloa' },
    { label: 'Sonora', value: 'Sonora' },
    { label: 'Tabasco', value: 'Tabasco' },
    { label: 'Tamaulipas', value: 'Tamaulipas' },
    { label: 'Tlaxcala', value: 'Tlaxcala' },
    { label: 'Veracruz', value: 'Veracruz' },
    { label: 'Yucatán', value: 'Yucatán' },
    { label: 'Zacatecas', value: 'Zacatecas' },
  ],
  US: [
    { label: 'Alabama', value: 'Alabama' },
    { label: 'Alaska', value: 'Alaska' },
    { label: 'American Samoa', value: 'American Samoa' },
    { label: 'Armed Forces Americas', value: 'Armed Forces Americas' },
    { label: 'Armed Forces Europe', value: 'Armed Forces Europe' },
    { label: 'Armed Forces Pacific', value: 'Armed Forces Pacific' },
    { label: 'Arizona', value: 'Arizona' },
    { label: 'Arkansas', value: 'Arkansas' },
    { label: 'California', value: 'California' },
    { label: 'Colorado', value: 'Colorado' },
    { label: 'Connecticut', value: 'Connecticut' },
    { label: 'Delaware', value: 'Delaware' },
    { label: 'District of Columbia', value: 'District of Columbia' },
    { label: 'Florida', value: 'Florida' },
    { label: 'Federated Micronesia', value: 'Federated Micronesia' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Guam', value: 'Guam' },
    { label: 'Hawaii', value: 'Hawaii' },
    { label: 'Idaho', value: 'Idaho' },
    { label: 'Illinois', value: 'Illinois' },
    { label: 'Indiana', value: 'Indiana' },
    { label: 'Iowa', value: 'Iowa' },
    { label: 'Kansas', value: 'Kansas' },
    { label: 'Kentucky', value: 'Kentucky' },
    { label: 'Louisiana', value: 'Louisiana' },
    { label: 'Maine', value: 'Maine' },
    { label: 'Marshall Islands', value: 'Marshall Islands' },
    { label: 'Maryland', value: 'Maryland' },
    { label: 'Massachusetts', value: 'Massachusetts' },
    { label: 'Michigan', value: 'Michigan' },
    { label: 'Minnesota', value: 'Minnesota' },
    { label: 'Mississippi', value: 'Mississippi' },
    { label: 'Missouri', value: 'Missouri' },
    { label: 'Montana', value: 'Montana' },
    { label: 'Nebraska', value: 'Nebraska' },
    { label: 'Nevada', value: 'Nevada' },
    { label: 'New Hampshire', value: 'New Hampshire' },
    { label: 'New Jersey', value: 'New Jersey' },
    { label: 'New Mexico', value: 'New Mexico' },
    { label: 'New York', value: 'New York' },
    { label: 'North Carolina', value: 'North Carolina' },
    { label: 'North Dakota', value: 'North Dakota' },
    { label: 'Northern Mariana Islands', value: 'Northern Mariana Islands' },
    { label: 'Ohio', value: 'Ohio' },
    { label: 'Oklahoma', value: 'Oklahoma' },
    { label: 'Oregon', value: 'Oregon' },
    { label: 'Palau', value: 'Palau' },
    { label: 'Pennsylvania', value: 'Pennsylvania' },
    { label: 'Puerto Rico', value: 'Puerto Rico' },
    { label: 'Rhode Island', value: 'Rhode Island' },
    { label: 'South Carolina', value: 'South Carolina' },
    { label: 'South Dakota', value: 'South Dakota' },
    { label: 'Tennessee', value: 'Tennessee' },
    { label: 'Texas', value: 'Texas' },
    {
      label: 'United States Minor Outlying Islands',
      value: 'United States Minor Outlying Islands',
    },
    { label: 'Utah', value: 'Utah' },
    { label: 'Vermont', value: 'Vermont' },
    { label: 'Virginia', value: 'Virginia' },
    { label: 'US Virgin Islands', value: 'US Virgin Islands' },
    { label: 'Washington', value: 'Washington' },
    { label: 'West Virginia', value: 'West Virginia' },
    { label: 'Wisconsin', value: 'Wisconsin' },
    { label: 'Wyoming', value: 'Wyoming' },
  ],
};

export default salesforceCounties;
